/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {updateEarningCard} from '../api'

export const useMutationUpdateEarningCard = createReactQueryMutationHook('updateEarningCard', updateEarningCard)
